import Image from 'next/image';

import { ActiveLink } from '@/ui/index';
import { useGetBreakPoints } from '@/constants/media';

import styles from './Service.module.scss';

const Service = ({ data, onClick }) => {
  const { isDesktop } = useGetBreakPoints();
  const iconSize = isDesktop ? 80 : 60;
  return (
    <ActiveLink href={data?.slug} itemScope itemType='https://schema.org/Thing'>
      <div className={styles.container} title={data?.text}>
        <div className={styles.intro} onClick={onClick}>
          <div className={styles.imageWrapper}>
            <div className={styles.image}>
              <Image
                alt={data?.text}
                title={data?.text}
                src={data?.icon}
                width={iconSize}
                height={iconSize}
                loading='lazy'
                objectFit='scale-down'
              />
            </div>
          </div>
        </div>
        {data?.text && <span className={styles.title}>{data?.text}</span>}
      </div>
    </ActiveLink>
  );
};

export default Service;
